import getProbabilityTagColor from '../../License/helpers/getProbabilityTagColor';

import {
  type ICommodityRimmEntity,
  type IMinistryDepartmentOffice,
  type TRimmEntity,
  type TRimmEntityOption,
} from '../data/rimmEntityTypes';
import { type RimmEntityType, type RimmSubEntityType } from '../data/rimmEntityEnums';

export const rimmEntityToOption = <T extends RimmEntityType | RimmSubEntityType>(
  rimmEntities: TRimmEntity[T][],
  withTag: boolean,
  tagKey?: keyof TRimmEntity[T]
): TRimmEntityOption[T][] =>
  rimmEntities.map((entity) => {
    if (withTag) {
      return {
        label: entity.code,
        value: entity.code,
        tag: {
          label: tagKey ? entity[tagKey] : entity.description,
        },
        ...entity,
      };
    }

    return {
      value: entity.code,
      label: {
        title: entity.code,
        description: entity.description,
      },
      ...entity,
    };
  }) as TRimmEntityOption[T][];

export function commodityCodeToOption(
  commodityCodes: ICommodityRimmEntity[]
): TRimmEntityOption[RimmEntityType.commodity][] {
  const showProbability = commodityCodes.some(({ probability }) => probability ?? false);

  return commodityCodes.map((entity) => {
    const { code, description, probability } = entity;
    const option: TRimmEntityOption[RimmEntityType.commodity] = {
      value: code,
      label: {
        title: code,
        description,
      },
      ...entity,
    };

    if (showProbability) {
      option.tag = {
        label: `${+(probability ?? 0).toFixed(2)} %`,
        color: getProbabilityTagColor(probability as number),
      };
    }

    return option;
  });
}

export function departmentOfficesToOptions(departmentOffices: IMinistryDepartmentOffice[]) {
  return departmentOffices.map(({ officeCode, officeDescription }) => ({
    label: officeCode,
    value: officeCode,
    tag: {
      label: officeDescription,
    },
  }));
}
